import axios from 'axios';

function errorResponse(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    // helitype() {
    //     return new Promise(async (resolve, reject) => {
    //         try {
    //             const { data } = await axios.get('/registration/helitype');
    //             resolve(data);
    //         } catch (error) {
    //             errorResponse(error, reject);
    //         }
    //     });
    // },
    save(data) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.post('/registration', data);
                resolve(resp);
            } catch (error) {
                errorResponse(error, reject);
            }
        });
    },
};